import React, { useEffect, useState } from "react";
import "./Profile.css";
import "./ProfileHero.css";
import Profileimg from "../../Images/profileimg.png";
import { FiCopy } from "react-icons/fi";
import { TfiWorld } from "react-icons/tfi";
import { FiUpload } from "react-icons/fi";
import { MdOutlineMoreHoriz } from "react-icons/md";
import Profiletabs from "./Profiletabs";
import Footer from "../Footer";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";
import Navbarnft_global from "../Navbars/Navbarnft_global";
import toast, { Toaster } from "react-hot-toast";
import { BsFillPencilFill } from "react-icons/bs";
import Web3 from "web3";
import { get_Marketplace_contract } from "../../Web3/Contract";
import { MAINNETTOKENS } from "../../Web3/ABI";
import { errorMessage } from "../../Web3/errors";
import placeholderImage from "../../Images/placeholder.svg";

function Profile({ UserWallet, URL, IPFS_image_baseUR, signMessage, logout }) {
  const slice = (str) => {
    const first = str.slice(0, 6);
    const second = str.slice(36);
    return first + "..." + second;
  };

  const [bannerlink, setBannerLink] = useState();
  const [logolink, setLogoLink] = useState("");
  const [username, setUserName] = useState();
  const [userbio, setUserBio] = useState();
  const [useremail, setUserEmail] = useState();
  const [websitelink, setWebsitelink] = useState();
  const [wallet, setWallet] = useState();
  const [jointime, setJoinTime] = useState();

  useEffect(() => {
    const init = async () => {
      axios
        .post(`${URL}/getuser`, {
          wallet: UserWallet,
        })
        .then((res) => {
          setBannerLink(res.data[0].bannerImage);
          setUserName(res.data[0].name);
          setLogoLink(res.data[0].logoImage);
          setUserBio(res.data[0].bio);
          setUserEmail(res.data[0].email);
          setWebsitelink(res.data[0].website);
          setWallet(res.data[0].Creator);
          setJoinTime(res.data[0].joinAt);
        });
    };
    init();
  }, [UserWallet]);

  // Sale payouts the marketplace could not deliver (e.g. a contract wallet that
  // rejects MAAL) wait here until claimed.
  const [pending, setPending] = useState([]);
  const loadPending = async () => {
    try {
      if (!UserWallet) return;
      const marketplace = await get_Marketplace_contract();
      const owed = [];
      for (const token of MAINNETTOKENS) {
        const amount = await marketplace.methods.pendingWithdrawals(token.address, UserWallet).call();
        if (amount !== "0") owed.push({ ...token, amount });
      }
      setPending(owed);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    loadPending();
  }, [UserWallet]);

  const claimPending = async (currency) => {
    try {
      const marketplace = await get_Marketplace_contract();
      await marketplace.methods.withdrawPending(currency, UserWallet).send({ from: UserWallet });
      notify("Claimed");
      loadPending();
    } catch (error) {
      console.log(error);
      toast.error(errorMessage(error));
    }
  };

  const Time_ago = (time) => {
    const date = moment(time).format("LLL");
    return date;
  };
  const notify = (msg) => toast.success(msg);

  const handleCopyClick = (txt) => {
    navigator.clipboard
      .writeText(txt)
      .then(() => {
        notify("copied");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const shortWallet = UserWallet ? slice(UserWallet) : "";
  const displayName = username || "Unnamed";

  return (
    <>
      <Navbarnft_global
        signMessage={signMessage}
        logout={logout}
        UserWallet={UserWallet}
        URL={URL}
      />
      <div className="pf-cover">
        <img src={bannerlink || placeholderImage} alt="" />
      </div>
      <div className="w3-container">
        <div className="pf-head">
          <div className="pf-avatar" aria-hidden="true">
            {displayName.charAt(0).toUpperCase()}
          </div>
          <div className="pf-info">
            <h1 className="pf-name">{displayName}</h1>
            {userbio && <p className="pf-bio">{userbio}</p>}
            <div className="pf-chips">
              <button
                type="button"
                className="pf-chip w3-glass"
                title="Copy wallet address"
                onClick={() => handleCopyClick(UserWallet)}
              >
                {shortWallet}
                <FiCopy />
              </button>
              {jointime && (
                <span className="pf-chip w3-glass">
                  Joined {moment(jointime).format("MMM YYYY")}
                </span>
              )}
            </div>
          </div>
          <div className="pf-actions">
            <Link to="/profilesetting" className="w3-btn w3-btn-primary">
              Edit profile
            </Link>
            <Link to="/mycollections" className="w3-btn">
              My collections
            </Link>
          </div>
        </div>
      </div>
      {pending.length > 0 && UserWallet === wallet ? (
        <div className="w3-container">
          {pending.map((item) => (
            <div key={item.address} className="d-f a-i-c m-y-1">
              <span className="m-r-1">
                Unclaimed sale proceeds: {Web3.utils.fromWei(item.amount, "ether")} {item.symbol}
              </span>
              <button className="edit-button b-1" onClick={() => claimPending(item.address)}>
                Claim
              </button>
            </div>
          ))}
        </div>
      ) : (
        ""
      )}
      <div className="w3-container">
        <Profiletabs
          URL={URL}
          IPFS_image_baseUR={IPFS_image_baseUR}
          UserWallet={UserWallet}
        />
      </div>
      <Footer />
      <Toaster />
    </>
  );
}

export default Profile;
